import { LOG_LEVELS } from '../constants/logLevels.js';
import settings from '../settings.js';

const typeLevels = {
    info: [LOG_LEVELS.DEBUG],
    warn: [LOG_LEVELS.DEBUG, LOG_LEVELS.WARN],
    error: [LOG_LEVELS.DEBUG, LOG_LEVELS.WARN, LOG_LEVELS.ERROR],
};
function isEnabled(levels) {
    return settings.logLevel ? levels.includes(settings.logLevel) : false;
}
function logger(type, ...args) {
    if (!isEnabled(typeLevels[type])) {
        return;
    }
    console[type]('[WowsCommerce]', ...args);
}
function log(...args) {
    logger('info', ...args);
}
function warn(...args) {
    logger('warn', ...args);
}
function error(...args) {
    logger('error', ...args);
}

export { error, log, warn };
//# sourceMappingURL=logger.js.map
